export const maskPhone = (value) => {
  if (!value) return value;

  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d+)/, "($1) $2")
    .replace(/(\d{5})(\d+)/, "$1-$2")
    .replace(/(\(\d{2}\) \d{4,5}-\d{4})(.+)/, "$1");
};
export const maskChassi = (value) => {
  if (!value) return value;
  value = value.slice(0, 17);

  return value;
};

export const maskRenavam = (value) => {
  if (!value) return value;
  value = value.slice(0, 11);

  return value.replace(/\D/g, "");
};

export const maskCNH = (value) => {
  if (!value) return value;
  value = value.slice(0, 11);

  return value.replace(/\D/g, "");
};
export const maskCPF = (value) => {
  if (!value) return value;

  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const maskCNPJ = (value) => {
  if (!value) return value;

  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const maskCEP = (value) => {
  if (!value) return value;
  return value.replace(/\D/g, "").replace(/^(\d{5})(\d{3})+?$/, "$1-$2");
};

export const maskLicensePlate = (value) => {
  if (!value) return "";

  return value
    .replace(/^[^a-z]/i, "")
    .replace(/^([a-z]{1,2})([^a-z])/i, "$1")
    .replace(/^([a-z]{3})([^\d])/i, "$1")
    .replace(/^([a-z]{3}\d)([^\w\d])/i, "$1")
    .replace(/^([a-z]{3}\d[\w\d])([^\d])/i, "$1")
    .replace(/^([a-z]{3}\d[\w\d]\d)([^\d])/i, "$1")
    .replace(/^([a-z]{3})(.{1,4})(.+)?/i, "$1-$2")
    .toUpperCase();
};

export const newMaskCurrency = (value: string | number): string => {
  const floatValue = parseFloat(String(value).replace(",", "."));
  if (isNaN(floatValue)) return "R$ 0,00";

  const formatted = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(floatValue);

  return formatted;
};

export const maskCurrency = (value) => {
  if (!value) return "R$ 0,00";

  if (!String(value).includes(",") && !String(value).includes(".")) {
    value = String(value).concat(".00");
  }
  const newValue = +String(value).replace(/(\D)/g, "") / 100;

  const valueMask = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(newValue);
  return valueMask;
};

export function formatCurrency(value): string {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function cleanMaskCurrency(currency: string) {
  return Number(currency.replace("R$", "").replace(",", "."));
}

export const maskCurrencyFieldAsaas = (value) => {
  if (!value) return "R$ 0,00";

  const valueString = parseFloat(value).toFixed(2);

  const cleanValue = valueString.replace(/(\D)/g, "");

  const newValue = +cleanValue / 100;

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(newValue);
};

export const maskCurrencyCalculate = (value: string): string => {
  if (!value) return "0,00";

  value = String(value);

  value = value.replace(",", ".");

  const newValue = parseFloat(value).toFixed(2);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseFloat(newValue));
};

export const maskCurrencyThousands = (value: string | number): string => {
  if (!value) return "R$ 0,00";

  // Garante que o valor seja tratado como string
  value = String(value);

  // Se o valor não tem vírgula nem ponto, adiciona ".00" (centavos)
  if (!value.includes(",") && !value.includes(".")) {
    value = value.concat(".00");
  }

  // Remove apenas os caracteres não numéricos, mas preserva o ponto como separador de milhar
  const newValue = +value.replace(/[^\d]/g, "") / 100;

  // Formata o valor como moeda brasileira
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(newValue);
};

export const maskOfCpfOrCnpj = (value) => {
  if (!value) return value;

  const cleaned = value.replace(/\D/g, "");

  if (cleaned.length <= 11) {
    return cleaned
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
      .slice(0, 14);
  } else {
    return cleaned
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2")
      .slice(0, 18);
  }
};

export const maskOfCNPJ = (value) => {
  if (!value) return value;

  let formattedValue = value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{2})/, "$1-$2");

  // Limitação de comprimento
  if (formattedValue.length > 18) {
    formattedValue = formattedValue.slice(0, 18);
  }

  return formattedValue;
};

export const formatUnity = (value) => {
  if (!value) return value;

  let formattedValue = String(value);

  formattedValue += " un";

  return formattedValue;
};
export const unmaskPhone = (value) => {
  if (!value) return value;

  return value.replace(/[()\s-]/g, "");
};

export const maskCpfOrCnpj = (value) => {
  if (!value) return value;

  // Remove todos os caracteres não numéricos
  let cleanedValue = value.replace(/\D/g, "");

  if (cleanedValue.length <= 11) {
    // Máscara para CPF: 999.999.999-99
    cleanedValue = cleanedValue
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2");
  } else {
    // Máscara para CNPJ: 99.999.999/9999-99
    cleanedValue = cleanedValue
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})/, "$1-$2");
  }

  // Limitação de comprimento para 14 dígitos (CPF) ou 18 dígitos (CNPJ)
  if (cleanedValue.length > 18) {
    cleanedValue = cleanedValue.slice(0, 18);
  }

  return cleanedValue;
};

export const maskCurrencyEdit = (value: string | number): string => {
  if (!value) return "R$ 0,00";

  // Verifica se o valor é um número decimal e converte para string
  let cleanValue = String(value);

  // Se o valor já contém um ponto decimal, tratamos isso corretamente
  if (cleanValue.includes(".")) {
    // Remove o ponto decimal para tratarmos o valor apenas como números
    const [intPart, decimalPart] = cleanValue.split(".");

    // Limpa a parte inteira e a parte decimal de qualquer caractere não numérico
    const cleanedIntPart = intPart.replace(/\D/g, "");
    const cleanedDecimalPart = decimalPart.slice(0, 2).replace(/\D/g, ""); // Considera apenas dois dígitos de centavos

    // Junta as partes de volta, garantindo que haja dois dígitos após o ponto
    cleanValue = cleanedIntPart + cleanedDecimalPart.padEnd(2, "0");
  } else {
    // Caso o valor não contenha ponto decimal, remove todos os caracteres não numéricos
    cleanValue = cleanValue.replace(/\D/g, "");
  }

  // Se não houver valor, retorna 0,00
  if (cleanValue === "") {
    return "R$ 0,00";
  }

  // Garante que sempre haja dois dígitos como centavos
  if (cleanValue.length === 1) {
    cleanValue = `0${cleanValue}`;
  } else if (cleanValue.length === 2) {
    cleanValue = `00${cleanValue}`;
  }

  // Divide o valor entre parte inteira e os centavos
  const intValue = cleanValue.slice(0, -2); // Parte inteira do valor
  const decimalValue = cleanValue.slice(-2); // Últimos dois dígitos são os centavos

  // Constrói o valor formatado para o campo com a parte inteira e os centavos
  const newValue = `${intValue}.${decimalValue}`;

  // Formata o número como moeda brasileira
  const valueMask = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(newValue));

  return valueMask;
};
